import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Mail } from 'lucide-react';
import { PublicHeader } from '@/components/PublicHeader';
import { PublicFooter } from '@/components/PublicFooter';
import { PUBLIC_CONTAINER } from '@/components/PublicContainer';

const API = process.env.REACT_APP_BACKEND_URL;
const FALLBACK = { title: 'Contact Sergeant TAP', intro: '' };

export default function ContactPage() {
  const [d, setD] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Contact · Sergeant TAP';
    axios.get(`${API}/api/public/site-content/contact`)
      .then((r) => setD(r.data))
      .catch(() => setD(FALLBACK));
  }, []);

  if (!d) {
    return (
      <div className="min-h-screen bg-white flex flex-col">
        <PublicHeader />
        <div className="flex-1 flex justify-center py-24"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-brand" /></div>
        <PublicFooter />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="contact-page">
      <PublicHeader />
      <main className="flex-1">
        <section className={`${PUBLIC_CONTAINER} pt-12 pb-16`}>
          <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 leading-tight" data-testid="contact-title">{d.title}</h1>
          {d.intro && <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-3xl" data-testid="contact-intro">{d.intro}</p>}

          <div className="mt-10 grid sm:grid-cols-2 gap-5">
            {(d.general_heading || d.general_email) && (
              <div className="bg-[#fafafa] border border-slate-100 rounded-xl p-6" data-testid="contact-general">
                {d.general_heading && <h2 className="text-lg font-bold text-slate-900">{d.general_heading}</h2>}
                {d.general_email && (
                  <a href={`mailto:${d.general_email}`} data-testid="contact-general-email"
                    className="mt-2 inline-flex items-center gap-2 text-brand font-medium hover:underline">
                    <Mail className="w-4 h-4" /> {d.general_email}
                  </a>
                )}
              </div>
            )}

            {(d.media_heading || d.media_email || d.media_text) && (
              <div className="bg-[#fafafa] border border-slate-100 rounded-xl p-6" data-testid="contact-media">
                {d.media_heading && <h2 className="text-lg font-bold text-slate-900">{d.media_heading}</h2>}
                {d.media_text && <p className="mt-2 text-[15px] text-slate-700 leading-relaxed">{d.media_text}</p>}
                {d.media_email && (
                  <a href={`mailto:${d.media_email}`} data-testid="contact-media-email"
                    className="mt-2 inline-flex items-center gap-2 text-brand font-medium hover:underline">
                    <Mail className="w-4 h-4" /> {d.media_email}
                  </a>
                )}
              </div>
            )}

            {(d.partnership_heading || d.partnership_text || d.partnership_cta_label) && (
              <div className="bg-[#fafafa] border border-slate-100 rounded-xl p-6 sm:col-span-2" data-testid="contact-partnership">
                {d.partnership_heading && <h2 className="text-lg font-bold text-slate-900">{d.partnership_heading}</h2>}
                {d.partnership_text && <p className="mt-2 text-[15px] text-slate-700 leading-relaxed max-w-3xl">{d.partnership_text}</p>}
                {d.partnership_cta_label && (
                  <Link to="/partner?source=about" data-testid="contact-partnership-cta"
                    className="mt-4 inline-flex btn-uppercase bg-brand hover:bg-brand-hover text-white px-6 py-2.5 rounded transition-colors">
                    {d.partnership_cta_label}
                  </Link>
                )}
              </div>
            )}

            {d.support_guidance && (
              <div className="rounded-xl p-6 border border-slate-100 sm:col-span-2" data-testid="contact-support">
                <p className="text-[15px] text-slate-700 leading-relaxed">{d.support_guidance}</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <PublicFooter />
    </div>
  );
}
